import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getAdminAuctions = async (currentUser, startDate = null, endDate = null, options = {}) => {
  try {
    const getAdminAuctionsFn = httpsCallable(functions, 'getAdminAuctionsByGroupV2');
    const result = await getAdminAuctionsFn({ 
      ...options,
      groupId: currentUser.activeGroupId || currentUser.groupId,
      requestedApp: 'group_web',
      startDate: startDate instanceof Date ? startDate.getTime() : null,
      endDate: endDate instanceof Date ? endDate.getTime() : null,
    });

    if (result.data.success === 'yes') {
      return {
        nextCursor: result.data.nextCursor || null,
        docs: result.data.data.map((auction) => ({
          id: auction.id,
          data: () => auction,
        })),
      };
    } else {
      return { success: 'no', message: result.data.message };
    }
  } catch (error) {
    console.error('Error obteniendo subastas de admin:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
